import isUserModerator from './is_user_moderator'
import isMessageApproved from './is_message_approved'
import isMessageOwnedByUser from './is_message_owned_by_user'

export default (fromMessage, uid, approvalStatus, role) => {
  if (isUserModerator(role)) return true
  if (isMessageApproved(approvalStatus)) return true
  if (isMessageOwnedByUser(fromMessage, uid)) return true

  return false
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/helpers/is_user_allowed_to_see_moderated_message.js
 **/